import { PlaySoundBoardType } from '../socket/listeners/voice-channel';

export enum ConversationMessageContentType {
  AUDIO = 'audio',
  FILE = 'file',
  IMAGE = 'image',
  TEXT = 'text',
  VIDEO = 'video',
  SOUNDBOARD = 'soundboard',
}

export type ConversationReactions = {
  emoji: string;
  users: string[];
};

export interface IConversationMessage {
  _id: string;
  content?: string;
  mediaRef?: string;
  mediaThumbnailRef?: string;
  contentType: ConversationMessageContentType;
  mimeType?: string;
  fileName?: string;
  fileSize?: number;
  replyTo?: IConversationMessage;
  author: string;
  edited?: boolean;
  reactions?: ConversationReactions[];
  workspace?: string;
  updatedAt?: string;
  createdAt: string;
  mediaContent?: string;
  hasMention?: boolean;
  soundBoard?: Partial<PlaySoundBoardType>;
}
